import React from 'react';
import { Badge } from 'react-bootstrap';
import ClinicalButton from '../../doctor/ui/ClinicalButton';
import { getNursingStatusMeta } from '../../../constants/nursingStatus';

export default function NursePassageHeader({ consultation, onBack }) {
  if (!consultation) return null;

  const statusMeta = getNursingStatusMeta(consultation.nursing_status);
  const patientName = consultation.patient_name || 'Patient';
  const matricule = consultation.member_matricule;
  const company = consultation.member_company_name;

  return (
    <header className="nr-passage-header nr-no-print">
      <div className="nr-passage-header__top">
        {onBack ? (
          <ClinicalButton variant="ghost" icon="chevronLeft" onClick={onBack} compact>
            Retour
          </ClinicalButton>
        ) : null}
        <span className="nr-passage-header__id">Passage #{consultation.id}</span>
      </div>
      <div className="nr-passage-header__main">
        <div className="nr-passage-header__patient">
          <h1 className="nr-passage-header__name">{patientName}</h1>
          <div className="nr-passage-header__meta">
            {matricule ? (
              <span className="nr-passage-header__matricule font-monospace">{matricule}</span>
            ) : null}
            {company ? <span className="nr-passage-header__company">{company}</span> : null}
          </div>
        </div>
        <Badge bg={statusMeta.variant} className="nr-passage-header__badge">
          {statusMeta.label}
        </Badge>
      </div>
    </header>
  );
}
